module.exports = function() {
  return new Worker("/" + "babel-transpiler.b15f094b.worker.js");
};